/**
 * @generated SignedSource<<4bb2e0649a1bb0cf6515d08cf99ee9b6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RelationshipTypeSelectInput_query$data = {
  readonly relationshipTypes: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly rowId: any;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "RelationshipTypeSelectInput_query";
};
export type RelationshipTypeSelectInput_query$key = {
  readonly " $data"?: RelationshipTypeSelectInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"RelationshipTypeSelectInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RelationshipTypeSelectInput_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SEQUENCE_ASC"
          ]
        }
      ],
      "concreteType": "RelationshipTypeConnection",
      "kind": "LinkedField",
      "name": "relationshipTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RelationshipType",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "relationshipTypes(orderBy:[\"SEQUENCE_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8bcfcfd63444736924f031a3d4b97f95";

export default node;
